import { render, staticRenderFns } from "./client-journal-counter.vue?vue&type=template&id=1d765a30"
import script from "./client-journal-counter.vue?vue&type=script&lang=js"
export * from "./client-journal-counter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports